<div class="ds-tab-nav" *ngIf="tabs" [ngClass]="size">
  <div *ngFor="let tab of tabs" (click)="changeTab(tab.id)" class="tab-element ds-caption-2" [ngClass]="{'active': tab.id === activeTab}">
    {{ tab.value | translate }}
  </div>
</div>
